/*import { useState } from "react";
import "./Addproperties.css";
import UploadWidget from "../../Components/uploadWidget/UploadWidget";
import { useNavigate } from "react-router-dom";
import axios from "axios";
//import Value from "./Value";

function Addproperties() {
  const [value, setValue] = useState("");
  const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate()

 

  const handleSubmit = async (e) => {
  e.preventDefault();    
    const formData = new FormData(e.target);
    const inputs = Object.fromEntries(formData);

   try {
      const res = await axios.post("http://104.214.177.15:8080/api/Property/AddProperty", {
        postData: {
          title: inputs.title,
          price: parseInt(inputs.price),
          address: inputs.address,
          city: inputs.city,
          bathroomNumber: parseInt(inputs.bathroomNumber),
          bedroomNumber: parseInt(inputs.bedroomNumber),
          licenseNumber: parseInt(inputs.licenseNumber),
          propertyCode: parseInt(inputs.propertyCode),
          type: inputs.type,
          propertyType: inputs.propertyType,
          image: images,
        },
        postDetail: {
          description: value,
          utilitiesPolicy: inputs.utilities,
          petPolicy: inputs.pet,
          incomePolicy: inputs.income,
          size: parseInt(inputs.size),
          school: parseInt(inputs.school),
        },
      });
      navigate("/singlepageproperty"+res.data.id)
    } catch (err) {
      console.log(err);
      setError(error);
    }
  };
 
    


  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>Add New Post</h1>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <div className="item">
              <label htmlFor="title">Title</label>
              <input id="title" name="title" type="text" />
            </div>
            <div className="item">
              <label htmlFor="price">Price</label>
              <input id="price" name="price" type="number" />
            </div>
            <div className="item">
              <label htmlFor="address">Address</label>
              <input id="address" name="address" type="text" />
            </div>
           
            <div className="item">
              <label htmlFor="city">City</label>
              <input id="city" name="city" type="text" />
            </div>
            <div className="item">
              <label htmlFor="bedroom">Bedroom Number</label>
              <input min={1} id="bedroom" name="bedroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="bathroom">Bathroom Number</label>
              <input min={1} id="bathroom" name="bathroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="license">License number</label>
              <input id="license" name="licenseNumber" type="text" />
            </div>
            <div className="item">
              <label htmlFor="pcode">Property Code</label>
              <input id="pcode" name="propertyCode" type="text" />
            </div>
            <div className="item">
              <label htmlFor="type">Type</label>
              <select name="type">
                <option value="rent" defaultChecked>
                  Rent
                </option>
                <option value="sale">sale</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="type">Property</label>
              <select name="propertyType">
                <option value="apartment">Apartment</option>
                <option value="house">House</option>
                <option value="villa">Villa</option>
                <option value="land">Land</option>
              </select>
            </div>

            <div className="item">
              <label htmlFor="utilities">Utilities Policy</label>
              <select name="utilitiesPolicy">
                <option value="owner">Owner is responsible</option>
                <option value="tenant">Tenant is responsible</option>
                <option value="shared">Shared</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="pet">Pet Policy</label>
              <select name="petPolicy">
                <option value="allowed">Allowed</option>
                <option value="not-allowed">Not Allowed</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="income">Income Policy</label>
              <input
                id="income"
                name="incomePolicy"
                type="text"
                placeholder="Income Policy"
              />
            </div>
            <div className="item">
              <label htmlFor="size">Total Size (sqft)</label>
              <input min={0} id="size" name="size" type="number" />
            </div>
            <div className="item">
              <label htmlFor="school">School</label>
              <input min={0} id="school" name="school" type="number" />
            </div>
            
            <div className="item description">
  <label htmlFor="desc">Description</label>
  <textarea 
    id="desc" 
    className="description-textarea"
    value={value} 
    onChange={(e) => setValue(e.target.value)} 
    rows="4"
    placeholder="Enter description here..."
  />
</div>


           
            <button className="sendButton" type="submit">Add</button>
            {error && <span>error</span>}
          </form>
        </div>
      </div>
      <div className="sideContainer">
        {Array.isArray(images) ?images.map((image, index) => (
            <img src={image} key={index} alt='' />
        )):<p>No images available</p>}
        <UploadWidget
          uwConfig={{
            multiple: true,
            cloudName: "akari",
            uploadPreset: "estate",
            folder: "posts",
          }}
          setState={setImages}
        />
        
        
      </div>
    </div> 
    
  );
}

export default Addproperties;

*/

/*import { useState } from "react";
import "./Addproperties.css";
import UploadWidget from "../../Components/uploadWidget/UploadWidget";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function Addproperties() {
  const [value, setValue] = useState("");
  const [images, setImages] = useState([]);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputs = Object.fromEntries(formData);

    const payload = {
      title: inputs.title,
      price: parseInt(inputs.price),
      address: inputs.address,
      city: inputs.city,
      bathroomNumber: parseInt(inputs.bathroomNumber),
      bedroomNumber: parseInt(inputs.bedroomNumber),
      licenseNumber: parseInt(inputs.licenseNumber),
      propertyCode: parseInt(inputs.propertyCode),
      type: inputs.type,
      propertyType: inputs.propertyType,
      image: images,
      description: value,
      utilitiesPolicy: inputs.utilitiesPolicy,
      petPolicy: inputs.petPolicy,
      incomePolicy: inputs.incomePolicy,
      size: parseInt(inputs.size),
      school: parseInt(inputs.school),
    };

    try {
      const res = await axios.post(
        "http://104.214.177.15:8080/api/Property/AddProperty",
        payload
      );
      navigate("/singlepageproperty/" + res.data.id);
    } catch (err) {
      console.error("Submission error:", err.response?.data || err.message);
      setError("Failed to submit. Please check all fields.");
    }
  };

  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>Add New Post</h1>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            <div className="item">
              <label htmlFor="title">Title</label>
              <input id="title" name="title" type="text" />
            </div>
            <div className="item">
              <label htmlFor="price">Price</label>
              <input id="price" name="price" type="number" />
            </div>
            <div className="item">
              <label htmlFor="address">Address</label>
              <input id="address" name="address" type="text" />
            </div>
            <div className="item">
              <label htmlFor="city">City</label>
              <input id="city" name="city" type="text" />
            </div>
            <div className="item">
              <label htmlFor="bedroom">Bedroom Number</label>
              <input min={1} id="bedroom" name="bedroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="bathroom">Bathroom Number</label>
              <input min={1} id="bathroom" name="bathroomNumber" type="number" />
            </div>
            <div className="item">
              <label htmlFor="license">License number</label>
              <input id="license" name="licenseNumber" type="text" />
            </div>
            <div className="item">
              <label htmlFor="pcode">Property Code</label>
              <input id="pcode" name="propertyCode" type="text" />
            </div>
            <div className="item">
              <label htmlFor="type">Type</label>
              <select name="type">
                <option value="rent" defaultChecked>
                  Rent
                </option>
                <option value="sale">Sale</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="propertyType">Property</label>
              <select name="propertyType">
                <option value="apartment">Apartment</option>
                <option value="house">House</option>
                <option value="villa">Villa</option>
                <option value="land">Land</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="utilitiesPolicy">Utilities Policy</label>
              <select name="utilitiesPolicy">
                <option value="owner">Owner is responsible</option>
                <option value="tenant">Tenant is responsible</option>
                <option value="shared">Shared</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="petPolicy">Pet Policy</label>
              <select name="petPolicy">
                <option value="allowed">Allowed</option>
                <option value="not-allowed">Not Allowed</option>
              </select>
            </div>
            <div className="item">
              <label htmlFor="incomePolicy">Income Policy</label>
              <input
                id="incomePolicy"
                name="incomePolicy"
                type="text"
                placeholder="Income Policy"
              />
            </div>
            <div className="item">
              <label htmlFor="size">Total Size (sqft)</label>
              <input min={0} id="size" name="size" type="number" />
            </div>
            <div className="item">
              <label htmlFor="school">School</label>
              <input min={0} id="school" name="school" type="number" />
            </div>
            <div className="item description">
              <label htmlFor="desc">Description</label>
              <textarea
                id="desc"
                className="description-textarea"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                rows="4"
                placeholder="Enter description here..."
              />
            </div>
            <button className="sendButton" type="submit">
              Add
            </button>
            {error && <span className="errorMessage">{error}</span>}
          </form>
        </div>
      </div>
      <div className="sideContainer">
        {Array.isArray(images) ? (
          images.map((image, index) => (
            <img src={image} key={index} alt="uploaded" />
          ))
        ) : (
          <p>No images available</p>
        )}
        <UploadWidget
          uwConfig={{
            multiple: true,
            cloudName: "akari",
            uploadPreset: "estate",
            folder: "posts",
          }}
          setState={setImages}
        />
      </div>
    </div>
  );
}

export default Addproperties;
*/




import "./Addproperties.css";
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Addproperties = () => {
  const [inputs, setInputs] = useState({});
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    // Convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64Image(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  {/*const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title: inputs.title || "",
      price: inputs.price || "",
      address: inputs.address || "",
      city: inputs.city || "",
      bathroomNumber: parseInt(inputs.bathroomNumber || 0),
      bedroomNumber: parseInt(inputs.bedroomNumber || 0),
      licenseNumber: inputs.licenseNumber || "",
      propertyCode: inputs.propertyCode || "",
      type: inputs.type || "",
      propertyType: inputs.propertyType || "",
      utilitiesPolicy: inputs.utilitiesPolicy || "",
      petPolicy: inputs.petPolicy || "",
      incomePolicy: inputs.incomePolicy || "",
      propertySize: inputs.propertySize || "",
      description: value || "",
      image: base64Image, // ← sending base64 image here
    };

    try {
      const res = await axios.post(
        "http://104.214.177.15:8080/api/Property/AddProperty",
        payload
      );
      console.log("API response:", res.data);
      navigate("/" + res.data);
    } catch (err) {
      const errorData = err.response?.data;
      if (errorData?.errors) {
        const errorMessages = Object.entries(errorData.errors)
          .map(([key, val]) => `${key}: ${val.join(", ")}`)
          .join("\n");
        setError(`Validation Error:\n${errorMessages}`);
      } else {
        setError("Failed to submit. Please check all fields.");
      }
    }
  };*/}
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      title: inputs.title || "",
      price: inputs.price || "",
      address: inputs.address || "",
      city: inputs.city || "",
      bathroomNumber: parseInt(inputs.bathroomNumber || 0),
      bedroomNumber: parseInt(inputs.bedroomNumber || 0),
      licenseNumber: inputs.licenseNumber || "",
      propertyCode: inputs.propertyCode || "",
      type: inputs.type || "",
      propertyType: inputs.propertyType || "",
      utilitiesPolicy: inputs.utilitiesPolicy || "",
      petPolicy: inputs.petPolicy || "",
      incomePolicy: inputs.incomePolicy || "",
      propertySize: inputs.propertySize || "",
      description: value || "",
      image: base64Image,
    };
  
    try {
      const res = await axios.post(
        "http://104.214.177.15:8080/api/Property/AddProperty",
        payload
      );
    
      console.log("API response:", res.data);
    
      // Navigate to property list page instead of single page
      navigate("/properties");
    } catch (err) {
      const errorData = err.response?.data;
      if (errorData?.errors) {
        const errorMessages = Object.entries(errorData.errors)
          .map(([key, val]) => `${key}: ${val.join(", ")}`)
          .join("\n");
        setError(`Validation Error:\n${errorMessages}`);
      } else {
        setError("Failed to submit. Please check all fields.");
      }
    }
    
  };
  

  return (
    <div className="newPostPage">
      <div className="formContainer">
        <h1>Add New Property</h1>
        <div className="wrapper">
          <form onSubmit={handleSubmit}>
            {[
              { label: "Title", name: "title", type: "text" },
              { label: "Price", name: "price", type: "text" },
              { label: "Address", name: "address", type: "text" },
              { label: "City", name: "city", type: "text" },
              { label: "Bedroom Number", name: "bedroomNumber", type: "number" },
              { label: "Bathroom Number", name: "bathroomNumber", type: "number" },
              { label: "License Number", name: "licenseNumber", type: "text" },
              { label: "Property Code", name: "propertyCode", type: "text" },
              { label: "Income Policy", name: "incomePolicy", type: "text" },
              { label: "Property Size", name: "propertySize", type: "text" },
            ].map(({ label, name, type }) => (
              <div className="item" key={name}>
                <label htmlFor={name}>{label}</label>
                <input
                  id={name}
                  name={name}
                  type={type}
                  onChange={handleChange}
                />
              </div>
            ))}

            {/* Dropdowns */}
            {[
              {
                label: "Type",
                name: "type",
                options: ["rent", "sale"],
              },
              {
                label: "Property Type",
                name: "propertyType",
                options: ["apartment", "house", "villa", "land"],
              },
              {
                label: "Utilities Policy",
                name: "utilitiesPolicy",
                options: ["owner", "tenant", "shared"],
              },
              {
                label: "Pet Policy",
                name: "petPolicy",
                options: ["allowed", "not-allowed"],
              },
            ].map(({ label, name, options }) => (
              <div className="item" key={name}>
                <label htmlFor={name}>{label}</label>
                <select name={name} onChange={handleChange}>
                  {options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            {/* Description */}
            <div className="item description">
              <label htmlFor="desc">Description</label>
              <textarea
                id="desc"
                className="description-textarea"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                rows="4"
                placeholder="Enter description here..."
              />
            </div>

            {/* Image Upload */}
            <div className="item">
              <label htmlFor="image">Upload Image</label>
              <input
                type="file"
                id="image"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>

            <button className="sendButton" type="submit">
              Add
            </button>
            {error && <span className="errorMessage">{error}</span>}
          </form>
        </div>
      </div>

      <div className="sideContainer">
        {selectedFile ? (
          <img
            src={URL.createObjectURL(selectedFile)}
            alt="Preview"
            style={{ maxWidth: "100%", marginBottom: "10px" }}
          />
        ) : (
          <p>No image selected</p>
        )}
      </div>
    </div>
  );
};

export default Addproperties;


